import React from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap-5';

import { Modal } from 'react-bootstrap-5';
import Select from 'react-select';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-solid-svg-icons';

import AssociatedProjectSelector from '../tasks/associated_project_selector';
import { Errors } from 'components/ui/errors';

export default class AddLeadsToProjectModal extends React.Component {
  static propTypes = {
    leadStatuses: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      status: PropTypes.string.isRequired
    })).isRequired,
    referralSources: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      label: PropTypes.string.isRequired
    })),
    selectedContactCount: PropTypes.number.isRequired,
    shown: PropTypes.bool.isRequired,
    onCancel: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired
  };

  static defaultProps = {
    referralSources: []
  }

  state = {
    errors: null,
    project: null,
    referralSource: this.props.referralSources[0],
    status: this.props.leadStatuses[0]
  }

  handleStatusChange = status => this.setState({ errors: null, status })
  handleReferralSourceChange = referralSource => this.setState({ errors: null, referralSource })
  handleProjectSelect = project => this.setState({ errors: null, project })
  handleProjectClear = () => this.setState({ errors: null, project: null })
  canSubmit = () =>  !!this.state.project && !!this.state.referralSource;

  handleCancelProject = () => {
    this.setState({
      errors: null,
      project: null
    }, () => {
      this.props.onCancel();
    });
  }

  handleSubmit = () => {
    const { leadStatuses, onSubmit } = this.props;
    const { project, status, referralSource } = this.state;

    this.canSubmit() && onSubmit(project.associatedModelId, status, referralSource.id).then(() => {
      this.setState({ errors: null, project: null, status: leadStatuses[0] });
    }).catch(errors => this.setState({ errors }));
  }

  render() {
    const { shown, selectedContactCount } = this.props;
    const { errors, project } = this.state;
    return (
      <Modal centered className="lead-modal" show={shown} size="lg" onHide={this.handleCancelProject}>
        <Modal.Header closeButton>
          <Modal.Title> Add {selectedContactCount} Leads to Project</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {errors && <Errors errors={errors} />}

          <div className="form-vertical-field-container">
            {project && project.associatedModelId ? this.renderProjectSelected() : this.renderProjectSelector()}

            <div className="form-group">
              <label className="form-label">Status</label>
              <Select
                getOptionLabel={options => options.status}
                getOptionValue={options => options.id}
                name="lead-status"
                options={this.props.leadStatuses}
                value={this.state.status}
                onChange={this.handleStatusChange}
              />
            </div>

            <div className="form-group">
              <label className="form-label">Referral Source</label>
              <Select
                getOptionLabel={options => options.label}
                getOptionValue={options => options.id}
                name="referral-source"
                options={this.props.referralSources}
                value={this.state.referralSource}
                onChange={this.handleReferralSourceChange}
              />
            </div>
          </div>

        </Modal.Body>
        <Modal.Footer>
          {this.renderButtons()}
        </Modal.Footer>
      </Modal>
    );
  }

  renderButtons() {
    return (
      <div>
        <button className="btn btn-ghost me-3" onClick={this.handleCancelProject}>Cancel</button>
        {this.canSubmit() ? this.renderSubmitButton() : this.renderWithTooltip(this.renderSubmitButton(), 'top')}
      </div>
    );
  }

  renderWithTooltip = (button, placement) => {
    const message = !this.state.project && 'Project can not be blank';
    const tooltip = <Tooltip id="disable-save-button">{message}</Tooltip>;

    return (
      <OverlayTrigger overlay={tooltip} placement={placement}>
        <span className="d-inline-block">{button}</span>
      </OverlayTrigger>
    );
  }

  renderSubmitButton() {
    const disabled = !this.canSubmit();
    return (
      <button
        className="btn btn-primary"
        disabled={disabled}
        style={disabled ? { pointerEvents: 'none' } : {}}
        onClick={this.handleSubmit}
      >
        Add Leads to Project
      </button>
    );
  }

  renderProjectSelected() {
    const { selectedContactCount } = this.props;
    return (
      <span> You are about to add
        <strong> {selectedContactCount} Leads </strong>
        to the following project:
        <div className="mt-2 mb-0 fs-large fw-semibold">
          {this.state.project.name}
          <FontAwesomeIcon
            className="ms-2 text-danger clickable"
            icon={faTimes}
            size="sm"
            onClick={this.handleProjectClear}
          />
        </div>
        <p className="mt-1 mb-2 text-muted">{this.state.project.address}</p>
      </span>
    );
  }

  renderProjectSelector() {
    return (
      <>
        <label className="form-label">Select Project</label>
        <AssociatedProjectSelector displayOnlyListings onModelAdded={this.handleProjectSelect} />
      </>
    );
  }
}
